export default "__VITE_ASSET__Czepjqe9__"